export enum SettingsTab {
  Currencies = "Currencies",
  CryptoCoins = "CryptoCoins",
  Languages = "Languages",
  GEO = "GEO",
  Email = "Email",
  Withdrawals = "Withdrawals",
  CustomerIO = "Customer.io",
  LiveChat = "Live Chat",
  VIP = "VIP",
  Maintenance = "Maintenance",
  Limits = "Limits",
  Gifts = "Gifts",
  VerificationProfile = "VerificationProfile",
  General = "General",
  DangerZone = "DangerZone"
}

export const SETTINGS_TAB_ORDER: SettingsTab[] = [
  SettingsTab.Currencies,
  SettingsTab.CryptoCoins,
  SettingsTab.Languages,
  SettingsTab.GEO,
  SettingsTab.Email,
  SettingsTab.Withdrawals,
  SettingsTab.Limits,
  SettingsTab.VIP,
  SettingsTab.Gifts,
  SettingsTab.VerificationProfile,
  SettingsTab.General
]

/** Destructive actions live in their own tab, always last, gated by SETTINGS_RESET. */
export const SETTINGS_DANGER_TAB = SettingsTab.DangerZone
